import { render, staticRenderFns } from "./AllRequests.vue?vue&type=template&id=191006a3&"
import script from "./AllRequests.vue?vue&type=script&lang=js&"
export * from "./AllRequests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports